// Scrolling text
// function Marquee(selector, speed) {
//   const parentSelector = document.querySelector(selector);
//   const clone = parentSelector.innerHTML;
//   const firstElement = parentSelector.children[0];
//   let i = 0;
//   console.log(firstElement);
//   parentSelector.insertAdjacentHTML('beforeend', clone);
//   parentSelector.insertAdjacentHTML('beforeend', clone);
//   parentSelector.insertAdjacentHTML('beforeend', clone);

//   setInterval(function () {
//     firstElement.style.marginLeft = `-${i}px`;
//     if (i > firstElement.clientWidth) {
//       i = 0;
//     }
//     i = i + speed;
//   }, 0);
// }
// window.addEventListener('load', Marquee('.marquee', 0.3))


// Testimonial filter
document.addEventListener("DOMContentLoaded", function() {

  const filterItems = document.querySelectorAll(".testimonial_filter_item, .testimonial__filter > .filter_button");
  const buttons = document.querySelectorAll(".testimonial__filter .filter_button");
  const cards = document.querySelectorAll(".testimonial");

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const selectedTag = button.getAttribute("data-tag");

      // ACTIVE state
      filterItems.forEach(item => item.classList.remove("active"));
      if (button.closest(".testimonial_filter_item")) {
        button.closest(".testimonial_filter_item").classList.add("active");
      } else {
        button.classList.add("active"); // for All button
      }

      // If ALL → show everything smoothly
      if (selectedTag === "All") {
        cards.forEach(card => {
          card.classList.remove("hidden");   // fade back in
        });
        return;
      }

      // Filter cards with fade animation
      cards.forEach(card => {
        const cardTag = card.getAttribute("data-tag");

        if (cardTag === selectedTag) {
          card.classList.remove("hidden"); // fade-in
        } else {
          card.classList.add("hidden"); // fade-out
        }
      });

    });
  });
});


// Video reel play/pause
document.addEventListener('DOMContentLoaded', () => {
  const videoWraps = document.querySelectorAll('.video_reel_wrapper');

  const resetVideoState = (wrap) => {
    const video = wrap.querySelector('.reel_video');
    const iconPlay = wrap.querySelector('.icon_play');
    const iconPause = wrap.querySelector('.icon_pause');

    video.pause();
    video.currentTime = 0;
    video.load(); // restore poster

    iconPlay.style.display = 'block';
    iconPause.style.display = 'none';
  };

  const toggleIcons = (video, playIcon, pauseIcon) => {
    playIcon.style.display = video.paused ? 'block' : 'none';
    pauseIcon.style.display = video.paused ? 'none' : 'block';
  };

  videoWraps.forEach(wrap => {
    const video = wrap.querySelector('.reel_video');
    const playBtn = wrap.querySelector('.play__btn');
    const iconPlay = wrap.querySelector('.icon_play');
    const iconPause = wrap.querySelector('.icon_pause');

    // Initial state
    resetVideoState(wrap);

    const handlePlayPause = () => {
      if (video.paused) {
        // Reset all other videos
        videoWraps.forEach(other => {
          if (other !== wrap) resetVideoState(other);
        });
        video.play();
      } else {
        video.pause();
      }

      toggleIcons(video, iconPlay, iconPause);
    };

    // Play/Pause on button click
    playBtn.addEventListener('click', handlePlayPause);

    // ✅ Play/Pause on video click
    video.addEventListener('click', handlePlayPause);

    // Reset after video ends
    video.addEventListener('ended', () => resetVideoState(wrap));
  });
});


// Account dropdown
document.addEventListener("DOMContentLoaded", function () {
  const accountDropdown = document.querySelector(".account-dropdown");

  accountDropdown.addEventListener("click", function (e) {
    const link = e.target.closest("a"); 
    if (link) {
      return; // DO NOT preventDefault
    }
    e.preventDefault();

    const closeIcon = this.querySelector(".account-dropdown .user-close-icon");
    const userIcon = this.querySelector(".account-dropdown .user-icon");
    const content = this.querySelector(".account-dropdown .dropdown-content");

    // Toggle close icon
    closeIcon.classList.toggle("show");

    // Remove show from user-icon when close-icon is shown
    if (closeIcon.classList.contains("show")) {
      userIcon.classList.remove("show");
    } else {
      // When closing -> show user icon again
      userIcon.classList.add("show");
    }

    // Toggle dropdown
    content.classList.toggle("show");
  });
});


// Fancybox
Fancybox.bind("[data-fancybox]", {
    dragToClose: false,
});


// Video reels popup play/pause 
document.addEventListener("DOMContentLoaded", () => {

  // 🎛 Helper: toggle play/pause UI
  const togglePlayUI = (popup, isPlaying) => {
    const playBtn = popup?.querySelector(".reel_play");
    if (!playBtn) return;

    const playIcon = playBtn.querySelector(".icon_play");
    const pauseIcon = playBtn.querySelector(".icon_pause");

    if (playIcon && pauseIcon) {
      playIcon.style.display = isPlaying ? "none" : "block";
      pauseIcon.style.display = isPlaying ? "block" : "none";
    }

    popup.classList.toggle("is-playing", isPlaying);
  };

  // 🎥 Helper: toggle video
  const toggleVideo = (video, popup) => {
    if (video.paused) {
      video.play();
      togglePlayUI(popup, true);
    } else {
      video.pause();
      togglePlayUI(popup, false);
    }
  };

  // 🎬 Click handlers (button + video)
  document.addEventListener("click", (e) => {

    // Play button
    const playBtn = e.target.closest(".reel_play");
    if (playBtn) {
      const popup = playBtn.closest(".video_reel__popup");
      const video = popup?.querySelector("video");
      if (video) toggleVideo(video, popup);
      return;
    }

    // Video click
    const video = e.target.closest(".reel_poster");
    if (video) {
      const popup = video.closest(".video_reel__popup");
      toggleVideo(video, popup);
      return;
    }

    // Mute button
    const muteBtn = e.target.closest(".reel_mute");
    if (muteBtn) {
      const popup = muteBtn.closest(".video_reel__popup");
      const video = popup?.querySelector("video");

      const iconMute = muteBtn.querySelector(".icon_mute");
      const iconUnmute = muteBtn.querySelector(".icon_unmute");

      if (video) {
        video.muted = !video.muted;

        if (iconMute && iconUnmute) {
          iconMute.style.display = video.muted ? "block" : "none";
          iconUnmute.style.display = video.muted ? "none" : "block";
        }
      }
      return;
    }

    // Close button
    if (e.target.closest(".is-close-button")) {
      resetAllVideos();
    }
  });

  // ⏸ Reset all videos
  function resetAllVideos() {
    document.querySelectorAll(".video_reel__popup video").forEach(video => {
      const popup = video.closest(".video_reel__popup");

      video.pause();
      video.currentTime = 0;
      video.load();

      togglePlayUI(popup, false);
    });
  }

  // 🎬 When video ends
  document.addEventListener("ended", (e) => {
    if (!e.target.matches(".reel_poster")) return;

    const popup = e.target.closest(".video_reel__popup");
    togglePlayUI(popup, false);
  }, true);

  // 🧭 Fancybox
  Fancybox.bind("[data-fancybox]", {
    Hash: false,
    on: {
      close: resetAllVideos,
      "Carousel.change": resetAllVideos,
    },
  });

});


// Discount offer slider
new Swiper('.discount-offer__slider', {
    loop: true,
    navigation: {
      nextEl: '.swiper--next',
      prevEl: '.swiper--prev',
    },
    slidesPerView: 1
});


// Customer Reviews slider
new Swiper('.customer-reviews__slider', {
    loop: true,
    navigation: {
      nextEl: '.review-swiper--next',
      prevEl: '.review-swiper--prev',
    },
    slidesPerView: 1
});


//Quick Button Slider
new Swiper('.quick-buttons-slider', {
    loop: false,
    freeMode: true, 
    spaceBetween: 0,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.quickbtn-swiper--next',
      prevEl: '.quickbtn-swiper--prev',
    }
});


// Product Navigation scroll
$(document).ready(function () {
  // Smooth scroll on nav click
  $('.product-nav-item a[href*="#"]').on('click', function (e) {
    console.log("stick scroll")
    e.preventDefault();

    var target = $(this).attr("href");

    $('html, body').stop().animate({
      scrollTop: $(target).offset().top - 160 // adjust offset if you have a sticky header
    }, 600);
  });
  // Highlight nav item on scroll
  $(window).on('scroll', function () {
    //console.log("scrolled")
    var scrollPos = $(window).scrollTop();
    var windowHeight = $(window).height();

    $('.shopify-section').each(function () {
      var sectionTop = $(this).offset().top;
      var sectionHeight = $(this).outerHeight();
      var sectionId = $(this).attr('id');

      // Check if section is in viewport (visible area)
      if (scrollPos + windowHeight / 2 >= sectionTop && scrollPos < sectionTop + sectionHeight) {
        $('.product-nav-item a').removeClass('active');
        $('.product-nav-item a[href="#' + sectionId + '"]').addClass('active');
      }
    });
  }).scroll(); // trigger on load



  // Sticky add to cart toggle option
jQuery(function($) {
  $(document).on('click', '.change-subscription', function() {
    console.log("jquery scroll");

    $(this).toggleClass('active');

    // Change text based on active class
    if ($(this).hasClass('active')) {
      $(this).text('Close');
    } else {
      $(this).text('Change');
    }

    $('.product-sticky-bar__options').stop(true, true).slideToggle(300);
  });
});
});

// Product navigation touch to the header
document.addEventListener("DOMContentLoaded", function () {
  const productNav = document.querySelector(".shopify-section--product-navigation");
  const headerWrapper = document.querySelector(".header__wrapper");
  const secondaryHeader = document.querySelector(".secondary__header");

  if (!productNav || !headerWrapper || !secondaryHeader) return;

  function checkTouch() {
    const navTop = productNav.getBoundingClientRect().top;
    const headerBottom = headerWrapper.getBoundingClientRect().bottom;

    // TOUCH condition (1px tolerance to avoid early firing)
    const isTouching = navTop <= headerBottom + 1 && navTop >= headerBottom - 1;

    secondaryHeader.classList.toggle("is-touching-header", isTouching);
    productNav.classList.toggle("is-touching-header", isTouching);
  }

  window.addEventListener("scroll", checkTouch, { passive: true });
  window.addEventListener("resize", checkTouch);

  checkTouch();
});


// Ingredient accordion sync with image
document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('details[data-id]');
  const images = document.querySelectorAll('.image-with-text__ingredient_media');

  function showImageById(id) {
    images.forEach(image => {
      image.style.display = image.id === id ? 'block' : 'none';
    });
  }

  // Initial state (if one accordion is already open)
  const opened = document.querySelector('details[open][data-id]');
  if (opened) {
    showImageById(opened.dataset.id);
  }

  accordions.forEach(accordion => {
    accordion.addEventListener('toggle', function () {
      if (this.open) {
        showImageById(this.dataset.id);
      }
    });
  });
});


// Video with text custom video sound on/off
document.addEventListener("DOMContentLoaded", function() {
  const soundIcon = document.querySelector('.sound_icon');
  const muteIcon = soundIcon?.querySelector('.icon__mute');
  const unmuteIcon = soundIcon?.querySelector('.icon__unmute');
  const videos = document.querySelectorAll('.video_wrap .video-with-text__video');

  if (!soundIcon || videos.length === 0) return;

  soundIcon.addEventListener('click', function() {
    let isMuted = videos[0].muted; // Assume all videos share the same state

    videos.forEach(video => {
      video.muted = !isMuted;
    });

    if (isMuted) {
      // 🔊 Now unmuted
      muteIcon.style.display = 'none';
      unmuteIcon.style.display = 'block';
    } else {
      // 🔇 Now muted
      muteIcon.style.display = 'block';
      unmuteIcon.style.display = 'none';
    }
  });
});


// Add to cart product from cutom button product link
document.addEventListener('click', async function (e) {

  const button = e.target.closest('.product_add_cart');
  if (!button) return;

  e.preventDefault();

  // Prevent double click
  if (button.getAttribute('aria-busy') === 'true') return;

  const productUrl = button.dataset.url;
  if (!productUrl) {
    console.error('Missing data-url');
    return;
  }

  try {

    // Start Impact loading animation
    button.setAttribute('aria-busy', 'true');

    const url = new URL(productUrl, window.location.origin);
    const handle = url.pathname.split('/products/')[1];

    const quantity = parseInt(url.searchParams.get('quantity')) || 1;
    const sellingPlan = url.searchParams.get('selling_plan');

    // 1️⃣ Get product
    const productRes = await fetch(`/products/${handle}.js`);
    const product = await productRes.json();

    const variant =
      product.variants.find(v => v.available) ||
      product.variants[0];

    // 2️⃣ Build payload
    const payload = {
      items: [{
        id: variant.id,
        quantity: quantity
      }]
    };

    if (sellingPlan) {
      payload.items[0].selling_plan = sellingPlan;
    }

    // 3️⃣ Add to cart
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    // 4️⃣ Refresh cart sections
    const sectionsRes = await fetch('/cart?sections=cart-drawer,header');
    const sections = await sectionsRes.json();

    if (sections['cart-drawer']) {
      const oldDrawer = document.getElementById('cart-drawer');
      if (oldDrawer) oldDrawer.outerHTML = sections['cart-drawer'];
    }

    if (sections['header']) {
      const header = document.querySelector('header');
      if (header) header.outerHTML = sections['header'];
    }

    // 5️⃣ Open drawer after DOM update
    requestAnimationFrame(() => {
      const newDrawer = document.getElementById('cart-drawer');
      if (newDrawer && typeof newDrawer.show === 'function') {
        newDrawer.show();
      }
    });

  } catch (error) {
    console.error('Cart error:', error);
  } finally {
    button.removeAttribute('aria-busy');
  }

});